import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { API, authHeaders, formatApiError } from "./AdminPage";
import { useAdminT } from "./adminI18n";

const inputCls =
  "w-full bg-luxury-black border border-luxury-border text-luxury-bone px-4 py-3 focus:outline-none focus:border-luxury-gold";

export const PasswordTab = () => {
  const { t } = useAdminT();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) {
      toast.error(t("كلمة المرور الجديدة يجب أن تكون ٨ أحرف على الأقل"));
      return;
    }
    if (form.new_password !== form.confirm) {
      toast.error(t("تأكيد كلمة المرور غير متطابق"));
      return;
    }
    setSaving(true);
    try {
      await axios.post(
        `${API}/auth/change-password`,
        { current_password: form.current_password, new_password: form.new_password },
        { headers: authHeaders() }
      );
      toast.success(t("تم تغيير كلمة المرور بنجاح — استخدميها في تسجيل الدخول القادم"));
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-password-tab" className="max-w-lg">
      <h2 className="font-serif text-3xl text-luxury-bone mb-8">{t("تغيير كلمة المرور")}</h2>
      <form onSubmit={submit} className="bg-luxury-surface border border-luxury-border p-8 space-y-5" data-testid="password-form">
        <div>
          <label className="block text-sm text-luxury-gray mb-2" htmlFor="pw-current">{t("كلمة المرور الحالية")}</label>
          <input
            id="pw-current"
            data-testid="pw-current-input"
            type="password"
            dir="ltr"
            value={form.current_password}
            onChange={(e) => setForm({ ...form, current_password: e.target.value })}
            className={inputCls}
            required
          />
        </div>
        <div>
          <label className="block text-sm text-luxury-gray mb-2" htmlFor="pw-new">{t("كلمة المرور الجديدة (٨ أحرف على الأقل)")}</label>
          <input
            id="pw-new"
            data-testid="pw-new-input"
            type="password"
            dir="ltr"
            value={form.new_password}
            onChange={(e) => setForm({ ...form, new_password: e.target.value })}
            className={inputCls}
            required
          />
        </div>
        <div>
          <label className="block text-sm text-luxury-gray mb-2" htmlFor="pw-confirm">{t("تأكيد كلمة المرور الجديدة")}</label>
          <input
            id="pw-confirm"
            data-testid="pw-confirm-input"
            type="password"
            dir="ltr"
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            className={inputCls}
            required
          />
        </div>
        <button
          data-testid="pw-save-button"
          type="submit"
          disabled={saving}
          className="flex items-center gap-3 bg-luxury-gold text-luxury-black font-semibold px-8 py-3 rounded-full hover:bg-luxury-goldLight transition-colors disabled:opacity-60"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" strokeWidth={1.5} />}
          {t("تغيير كلمة المرور")}
        </button>
      </form>
    </div>
  );
};
